import { createAction, props } from '@ngrx/store';
import { IValidateTokenRequest, IValidateTokenResponse } from '../models/validate-token.model';

export const loadValidateToken = createAction(
  '[Auth] Load Validate Token',
  props<{ request: IValidateTokenRequest }>()
);

export const loadValidateTokenSuccess = createAction(
  '[Auth] Load Validate Token Success',
  props<{ response: IValidateTokenResponse }>()
);

export const loadValidateTokenFailure = createAction(
  '[Auth] Load Validate Token Failure',
  props<{ error: Error | any }>()
);
